import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BannerSlider.css';

const slides = [
  {
    id: 1,
    title: 'Bold and Inspiring',
    subtitle: 'Transforming Ideas into Digital Masterpieces',
    description: 'Elevate your brand with innovative web design, intuitive user experiences, and cutting-edge digital solutions. Whether you\'re launching a startup or scaling an enterprise, we craft visually stunning, performance-driven websites that captivate audiences and drive real results.',
    linkText: 'Discover Our Work!',
    indicatorText: 'Digital Masterpieces',
    image: 'assets/home-bg-1.jpg',


  },

  /*  {
     id: 2,
     title: 'Sleek and Professional',
     subtitle: 'Crafting Unique Digital Journeys',
     description: 'Exceptional website design tailored to your brand’s vision.',
     linkText: 'Get Started Today!',
     indicatorText: 'Digital Journeys',
     image: 'assets/banners/Home-bg-1.webp',  
   },*/
  {
    id: 3,
    title: 'Modern and Dynamic',
    subtitle: 'Unleash Creativity with Cutting Edge Web Design',
    description: 'We create visually stunning, mobile-responsive websites optimized for performance, SEO, and user engagement. Our modern web design solutions are tailored to boost conversions and establish a strong digital presence for your brand.',
    linkText: 'View Our Portfolio!',
    indicatorText: 'Cutting Edge',
    image: 'assets/images/New folder/h2.avif',
    // imageSecond: 'assets/banners/sss.webp',
  },
  {
    id: 4,
    title: 'Artistic and Vibrant',
    subtitle: 'Innovating the Future with Creative Vision',
    description: 'Our creative design services blend artistic vision with strategic branding to deliver SEO-friendly, high-impact websites that tell your brand story and engage audiences across all platforms.',
    linkText: 'See Our Creations!',
    indicatorText: 'Brand to Life',

    image: 'assets/images/New folder/h2.avif',
    // imageSecond: 'assets/banners/sss.webp',
  },
  /*   {
      id: 5,
      title: 'Minimalist and Elegant',
      subtitle: 'Design That Speaks Volumes',
      description: 'Sophisticated web solutions for the modern business.',
      linkText: 'Learn More!',
      indicatorText: 'Modern Business',
      image: 'assets/banners/Home-bg-4.webp',  
    }, */
];

const BannerSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoSlide, setAutoSlide] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    let slideInterval = null;
    if (autoSlide) {
      slideInterval = setInterval(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
      }, 5000);
    }
    return () => clearInterval(slideInterval);
  }, [autoSlide]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleIndicatorClick = (index) => {
    setCurrentSlide(index);
    setAutoSlide(false);
  };

  const handleToggleAutoSlide = () => {
    setAutoSlide((prevAutoSlide) => !prevAutoSlide);
  };

  return (
    <section className="section main-banner" id="top" data-section="section1">
      <div className='bg-video'>
        <img src={slides[currentSlide].image} loading='lazy' alt={`Banner for slide ${currentSlide + 1}`} className='first-image' />
        {/* <img src={slides[currentSlide].imageSecond} loading='lazy' alt={`Banner for slide ${currentSlide + 1}`} className='second-image' /> */}
      </div>
      <div className="images-overlay header-text">
        <div className="container">

          <div className=" caption row">
            <div className="left-content">
              <h1>{slides[currentSlide].subtitle}</h1>
            </div>
            <div className="right-content">
              <hr
                className="orange-line"
                style={{ height: '5px', width: '50px', background: '#003bfd ', opacity: '1' }}
              />
              <p>{slides[currentSlide].description}</p>
              <br />
              <Link to='/kumbhatech-affordable-website-design-chennai' className='text-white'>{slides[currentSlide].linkText} <i className="fa fa-angle-right abt-btn-blue" aria-hidden="true"></i></Link>

            </div>
          </div>

        </div>
        <div className="indicator-row">
          <div className='ind-container'>
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => handleIndicatorClick(index)}
              >
                {screenWidth > 992 ? slide.indicatorText : <span className="dot">■</span>}
              </div>
            ))}
            <button className="toggle-auto-slide" style={{ display: 'none' }} onClick={handleToggleAutoSlide}>
              {autoSlide ? <i className="fa fa-pause" aria-hidden="true"></i> : <i className="fa fa-play" aria-hidden="true"></i>}
            </button>
          </div>
        </div>
      </div>

    </section >
  );
};

export default BannerSlider;
